export function getRowStart(index: number) {
     index = index + 1;
     switch (index) {
        case 2:
            return "row-start-2";
        case 3:
            return "row-start-3";
        case 4:
            return "row-start-4";
        case 5:
            return "row-start-5";
        case 6:
            return "row-start-6";
        case 7:
            return "row-start-7";
        case 8:
            return "row-start-8";
        case 9:
            return "row-start-9";
        case 10:
             return "row-start-10";
        case 11:
            return "row-start-11";
        case 12:
            return "row-start-12";
        case 13:
            return "row-start-13";
        case 14:
            return "row-start-14";
        case 15:
            return "row-start-15";
        case 16:
            return "row-start-16";
        case 17:
            return "row-start-17";
        case 18:
            return "row-start-18";
        case 19:
            return "row-start-19";
        case 20:
             return "row-start-20";
         case 21:
             return "row-start-21";
         case 22:
             return "row-start-22";
         case 23:
             return "row-start-23";
         case 24:
             return "row-start-24";
         case 25:
             return "row-start-25";
         case 26:
             return "row-start-26";
         case 27:
             return "row-start-27";
         case 28:
             return "row-start-28";
         case 29:
             return "row-start-29";
         case 30:
             return "row-start-30";
         case 31:
             return "row-start-31";
         case 32:
             return "row-start-32";
         case 33:
             return "row-start-33";
         case 34:
             return "row-start-34";
         case 35:
             return "row-start-35";
         case 36:
             return "row-start-36";
         case 37:
             return "row-start-37";
         case 38:
             return "row-start-38";
         case 39:
             return "row-start-39";
         case 40:
             return "row-start-40";
         case 41:
             return "row-start-41";
         case 42:
             return "row-start-42";
         case 43:
             return "row-start-43";
         case 44:
             return "row-start-44";
         case 45:
             return "row-start-45";
         case 46:
             return "row-start-46";
         case 47:
             return "row-start-47";
         case 48:
             return "row-start-48";
         case 49:
             return "row-start-49";
         case 50:
             return "row-start-50";
         case 51:
             return "row-start-51";
         case 52:
             return "row-start-52";
         case 53:
             return "row-start-53";
         case 54:
             return "row-start-54";
         case 55:
             return "row-start-55";
         case 56:
             return "row-start-56";
         case 57:
             return "row-start-57";
         case 58:
             return "row-start-58";
         case 59:
             return "row-start-59";
         case 60:
             return "row-start-60";
         case 61:
             return "row-start-61";
         case 62:
             return "row-start-62";
         case 63:
             return "row-start-63";
         case 64:
             return "row-start-64";
         case 65:
             return "row-start-65";
         case 66:
             return "row-start-66";
         case 67:
             return "row-start-67";
         case 68:
             return "row-start-68";
         case 69:
             return "row-start-69";
         case 70:
             return "row-start-70";
         case 71:
             return "row-start-71";
         case 72:
             return "row-start-72";
         case 73:
             return "row-start-73";
         case 74:
             return "row-start-74";
         case 75:
             return "row-start-75";
         case 76:
             return "row-start-76";
         case 77:
             return "row-start-77";
         case 78:
             return "row-start-78";
         case 79:
             return "row-start-79";
         case 80:
             return "row-start-80";
         case 81:
             return "row-start-81";
         case 82:
             return "row-start-82";
         case 83:
             return "row-start-83";
         case 84:
             return "row-start-84";
         case 85:
             return "row-start-85";
         case 86:
             return "row-start-86";
         case 87:
             return "row-start-87";
         case 88:
             return "row-start-88";
         case 89:
             return "row-start-89";
         case 90:
             return "row-start-90";
         case 91:
             return "row-start-91";
         case 92:
             return "row-start-92";
         case 93:
             return "row-start-93";
         case 94:
             return "row-start-94";
         case 95:
             return "row-start-95";
         case 96:
             return "row-start-96";
        case 1:
        default:
            return "row-start-1";
    }
}

export function getRowSpan(duration: number) {
    switch (duration * 2) {
        case 2:
            return "row-span-2";
        case 3:
            return "row-span-3";
        case 4:
            return "row-span-4";
        case 5:
            return "row-span-5";
        case 6:
            return "row-span-6";
        case 7:
            return "row-span-7";
        case 8:
            return "row-span-8";
        case 9:
            return "row-span-9";
        case 10:
            return "row-span-10";
        case 11:
            return "row-span-11";
        case 12:
            return "row-span-12";
        case 1:
        default:
            return "row-span-1";
    }
}

export function get15minuteIntervals() {
 return[
"12:00AM",
"12:15AM",
"12:30AM",
"12:45AM",
"1:00AM",
"1:15AM",
"1:30AM",
"1:45AM",
"2:00AM",
"2:15AM",
"2:30AM",
"2:45AM",
"3:00AM",
"3:15AM",
"3:30AM",
"3:45AM",
"4:00AM",
"4:15AM",
"4:30AM",
"4:45AM",
"5:00AM",
"5:15AM",
"5:30AM",
"5:45AM",
"6:00AM",
"6:15AM",
"6:30AM",
"6:45AM",
"7:00AM",
"7:15AM",
"7:30AM",
"7:45AM",
"8:00AM",
"8:15AM",
"8:30AM",
"8:45AM",
"9:00AM",
"9:15AM",
"9:30AM",
"9:45AM",
"10:00AM",
"10:15AM",
"10:30AM",
"10:45AM",
"11:00AM",
"11:15AM",
"11:30AM",
"11:45AM",
"12:00PM",
"12:15PM",
"12:30PM",
"12:45PM",
"1:00PM",
"1:15PM",
"1:30PM",
"1:45PM",
"2:00PM",
"2:15PM",
"2:30PM",
"2:45PM",
"3:00PM",
"3:15PM",
"3:30PM",
"3:45PM",
"4:00PM",
"4:15PM",
"4:30PM",
"4:45PM",
"5:00PM",
"5:15PM",
"5:30PM",
"5:45PM",
"6:00PM",
"6:15PM",
"6:30PM",
"6:45PM",
"7:00PM",
"7:15PM",
"7:30PM",
"7:45PM",
"8:00PM",
"8:15PM",
"8:30PM",
"8:45PM",
"9:00PM",
"9:15PM",
"9:30PM",
"9:45PM",
"10:00PM",
"10:15PM",
"10:30PM",
"10:45PM",
"11:00PM",
"11:15PM",
"11:30PM",
"11:45PM",
    ]
}

export function get30minuteIntervals() {
    return ["12AM", "12:30AM", "1AM", "1:30AM", "2AM", "2:30AM", "3AM", "3:30AM", "4AM", "4:30AM", "5AM", "5:30AM", "6AM", "6:30AM", "7AM", "7:30AM", "8AM", "8:30AM", "9AM", "9:30AM", "10AM", "10:30AM", "11AM", "11:30AM", "12PM", "12:30PM", "1PM", "1:30PM", "2PM", "2:30PM", "3PM", "3:30PM", "4PM", "4:30PM", "5PM", "5:30PM", "6PM", "6:30PM", "7PM", "7:30PM", "8PM", "8:30PM", "9PM", "9:30PM", "10PM", "10:30PM", "11PM", "11:30PM",]
}